
module.exports = {"attributes":{"width":"18","height":"18","viewBox":"0 0 18 18"},"content":"<path d=\"M8.2 0h1.6l.4 7.8 7.8.4v1.6l-7.8.4-.4 7.8H8.2l-.4-7.8L0 9.8V8.2l7.8-.4.4-7.8z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
